import { render, staticRenderFns } from "./SMSNotificationRules.vue?vue&type=template&id=dc085b66&scoped=true&"
import script from "./SMSNotificationRules.vue?vue&type=script&lang=js&"
export * from "./SMSNotificationRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc085b66",
  null
  
)

export default component.exports